module.exports = __webpack_public_path__ + "static/img/orderTurn.ddd14f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orderTurn.png
// module id = sGaz
// module chunks = 0